import _extends from '@babel/runtime/helpers/extends';
import React__default, { useState } from 'react';
import styled from 'styled-components';
import PT from 'prop-types';
import { I as InputFormGroup } from '../InputFormGroup/InputFormGroup-DEUVo2w4.js';
import { P as PillBox } from './PillBox-CvzLGSKH.js';
import { B as Button } from '../Button/Button-BhD27vh-.js';

const ListBuilderWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-qxh3rc-0"
})(["height:100%;width:100%;display:flex;flex-direction:column;"]);
const ListBuilderBaseWrapper = /*#__PURE__*/styled('div').withConfig({
  componentId: "sc-storm-ui-30063520__sc-qxh3rc-1"
})(["display:flex;flex:0 0 auto;flex-direction:column;border:1px solid ", ";padding:10px;"], ({
  theme
}) => theme.palette.gray[300]);
const ListBuilderInputWrapper = /*#__PURE__*/styled('form').withConfig({
  componentId: "sc-storm-ui-30063520__sc-qxh3rc-2"
})(["display:flex;flex:1 1 auto;align-items:center;justify-content:space-between;gap:10px;"]);
const ListBuilderInput = ({
  id,
  addText,
  items,
  onAdd,
  onRemovePill,
  onRemoveAll,
  removeAllLabel,
  disableAdd,
  onChange,
  renderPill,
  disabled,
  ...rest
}) => {
  const [inputVal, setInputVal] = useState('');
  const handleInputChange = event => {
    var _event$target;
    setInputVal((_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    onChange === null || onChange === void 0 || onChange(event);
  };
  const handleOnAdd = event => {
    onAdd === null || onAdd === void 0 || onAdd(event, inputVal);
    setInputVal('');
  };
  return /*#__PURE__*/React__default.createElement(ListBuilderWrapper, {
    id: id
  }, /*#__PURE__*/React__default.createElement(ListBuilderBaseWrapper, null, /*#__PURE__*/React__default.createElement(ListBuilderInputWrapper, {
    onSubmit: event => event.preventDefault()
  }, /*#__PURE__*/React__default.createElement(InputFormGroup, _extends({}, rest, {
    fullWidth: true,
    id: `${id}-input`,
    value: inputVal,
    onChange: handleInputChange,
    disabled: disabled
  })), /*#__PURE__*/React__default.createElement(Button, {
    type: "submit",
    onClick: handleOnAdd,
    disabled: disabled || disableAdd,
    tabIndex: 0
  }, addText))), items && items.length ? /*#__PURE__*/React__default.createElement(PillBox, {
    style: {
      borderTop: '0'
    },
    pills: items,
    onRemovePill: onRemovePill,
    onRemoveAll: onRemoveAll,
    removeAllLabel: removeAllLabel,
    renderPill: renderPill
  }) : null);
};
ListBuilderInput.propTypes = {
  /** The unique identifier */
  id: PT.string.isRequired,
  /** The text displayed in the Button used to add a new Pill */
  addText: PT.string.isRequired,
  /** The aria-label for the Button used to remove all Pills */
  removeAllLabel: PT.string.isRequired,
  /** The list of items displayed as Pills */
  items: PT.arrayOf(PT.arrayOf(PT.oneOfType([PT.string.isRequired, PT.object]))),
  /** Should the add Button be disabled */
  disableAdd: PT.bool,
  /** Adds a message below the input, which will update based on error/success/warning */
  message: PT.oneOfType([PT.string, PT.func]),
  /** Specifies the type of message to be displayed (error, warning, success) */
  statusType: PT.oneOf(['error', 'warning', 'success']),
  /** The function called when a new Pill is added */
  onAdd: PT.func,
  /** The function called when a Pill is removed */
  onRemovePill: PT.func,
  /** The function called when the Button to remove all Pills is clicked */
  onRemoveAll: PT.func,
  /** Can be used to render a custom Pill */
  renderPill: PT.func
};
ListBuilderInput.defaultProps = {
  onAdd: undefined,
  onRemovePill: undefined,
  onRemoveAll: undefined,
  items: [],
  disableAdd: false,
  message: undefined,
  statusType: undefined,
  renderPill: undefined
};

export { ListBuilderInput as L };
//# sourceMappingURL=ListBuilderInput-dous6W2H.js.map
